(function () {
 'use strict';
 if (customElements.get('leha-footer-content')) return;
 customElements.define('leha-footer-content', class extends HTMLElement {
  connectedCallback() {
   this.controller?.abort(); this.controller = new AbortController();
   const signal = this.controller.signal;
   this.groups = Array.from(this.querySelectorAll('[data-leha-footer-group]'));
   this.desktop = matchMedia('(min-width:768px)');
   this.mobileStates = this.groups.map(()=>false);
   const apply = () => this.groups.forEach((group,index) => {
    group.open = this.desktop.matches || this.mobileStates[index];
    const summary = group.querySelector('summary'); summary.tabIndex = this.desktop.matches ? -1 : 0;
   });
   this.groups.forEach((group,index) => group.querySelector('summary').addEventListener('click', event => {
    if (this.desktop.matches) event.preventDefault(); else this.mobileStates[index] = !group.open;
   }, {signal}));
   this.desktop.addEventListener('change',apply,{signal}); apply();
   const returnTo = this.querySelector('[data-leha-newsletter-return]');
   if (returnTo) {
    const url = new URL(window.location.href); url.hash = this.querySelector('form').id;
    url.searchParams.delete('customer_posted'); url.searchParams.delete('form_type');
    returnTo.value = url.pathname+url.search+url.hash;
   }
  }
  disconnectedCallback() { this.controller?.abort(); }
 });
})();
